import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { useIsMobile } from '@/hooks/use-mobile'
import { ReactNode } from 'react'

interface PageLayoutProps {
  title?: string | ReactNode
  description?: string | ReactNode
  children?: ReactNode
  footer?: ReactNode
  showSidebarTrigger?: boolean
}

export default function PageLayout({
  title,
  description,
  children,
  footer,
  showSidebarTrigger = true
}: PageLayoutProps) {
  const isMobile = useIsMobile()
  return (
    <Card className="layout_container bg-background">
      <CardHeader className="layout_header">
        <CardTitle className="text-2xl md:text-3xl lg:text-4xl w-full">
          {isMobile && showSidebarTrigger && <SidebarTrigger />}
          {title}
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>

      <CardContent className="layout_main">{children}</CardContent>

      {footer && <CardFooter className="layout_footer">{footer}</CardFooter>}
    </Card>
  )
}
